module.exports = __webpack_public_path__ + "static/media/11.eaa1804a.jpg";